import { useEffect, useState } from 'react';
import { Platform } from 'react-native';

export default function useFabBottomOffset(defaultOffset = 24) {
  const [fabBottomOffset, setFabBottomOffset] = useState<number>(defaultOffset);

  useEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return undefined;
    const computeOffset = () => {
      try {
        let navEl: Element | null = document.getElementById('app-bottom-nav-portal');
        
        // If portal container exists, try to find the content element inside it
        if (navEl) {
          if (navEl.children.length > 0) {
            // Prefer the child that is fixed positioned (the footer wrapper)
            let target = navEl.children[0];
            for (let i = 0; i < navEl.children.length; i++) {
              const child = navEl.children[i] as HTMLElement;
              // Check inline style first (fast) then computed
              if (child.style?.position === 'fixed' || (window.getComputedStyle(child).position === 'fixed')) {
                target = child;
                break;
              }
            }
            navEl = target;
          } else {
            // Container exists but empty -> treat as not found
            navEl = null;
          }
        }

        if (!navEl) {
          const fixedEls = Array.from(document.querySelectorAll('*')).filter((e) => getComputedStyle(e as Element).position === 'fixed');
          navEl = fixedEls.find((e) => {
            try {
              const r = (e as Element).getBoundingClientRect();
              return Math.abs(r.bottom - window.innerHeight) < 8 && r.height > 20;
            } catch (e) {
              return false;
            }
          }) || null;
        }
        if (navEl) {
          const rect = navEl.getBoundingClientRect();
          const gap = 12;
          // If we found the portal but height is 0 (e.g. not layout yet), assume a safe default
          const isPortal = navEl.id === 'app-bottom-nav-portal' || navEl.parentElement?.id === 'app-bottom-nav-portal';
          const height = rect.height || (isPortal ? 80 : 0);
          
          if (height > 0) {
            const offset = Math.ceil(height + gap);
            setFabBottomOffset(offset);
            return;
          }
        }
      } catch (e) {
        // ignore
      }
      setFabBottomOffset(defaultOffset);
    };
    computeOffset();
    window.addEventListener('resize', computeOffset);
    const mo = new MutationObserver(computeOffset);
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    return () => {
      window.removeEventListener('resize', computeOffset);
      try { mo.disconnect(); } catch (e) {}
    };
  }, [defaultOffset]);

  return fabBottomOffset;
}
